<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备告警通知配置
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="operation/deviceAlarmInform/export/exportDeviceUser" :params="seefrom" method="post" :needUserId="true"></downloadBtn>
          <button class="GreenSmBtn" @click="toAddNew">批量设置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom.deviceMark"></el-input>
              </el-form-item>
              <el-form-item label="设备状态">
                <el-select placeholder="请输入设备状态" v-model="seefrom.status" :popper-append-to-body="false">
                  <el-option :value="''">请选择</el-option>
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input placeholder="请选择区域" v-model="seefrom.area" @focus="changeAreaMode(1)"></el-input>
              </el-form-item>
              <el-form-item label="通知人姓名">
                <el-input placeholder="请输入通知人姓名" v-model="seefrom.informer"></el-input>
              </el-form-item>
              <el-form-item label="通知人手机号">
                <el-input placeholder="请输入通知人手机号" v-model="seefrom.phone"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/deviceAlarmInform/getPageList" :parent="self" :config="config" :other="other" ref="deviceList" :height="400">
            <template slot="last">
              <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="toEdit(scope.$index, scope.row)">编辑</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteDevice(scope.$index, scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- 弹出框 -->
        <el-dialog class="cust_dialog" :visible.sync="displayForm" :title="title" :close-on-click-modal="false" @close="closeDialog">
          <template>
            <el-form ref="dynamicValidateForm" class="demo-dynamic">
              <el-form-item style="display: inline-block; width: 100px"></el-form-item>
              <el-form-item :label="'通知人姓名'" style="display: inline-block; margin-bottom: 0px; width: 170px"></el-form-item>
              <el-form-item :label="'通知人电话'" style="display: inline-block; margin-bottom: 0px; width: 170px"></el-form-item>

              <el-form-item v-for="(item, index) in dynamicValidateForm" :label="'通知人信息'" :key="index" style="display: inline-block">
                <el-form-item :prop="'dynamicValidateForm.' + index + '.informer'" style="display: inline-block">
                  <el-input class="d_name" v-model="item.informer" placeholder="通知人姓名"></el-input>
                </el-form-item>
                <el-form-item :prop="'dynamicValidateForm.' + index + '.phone'" style="display: inline-block">
                  <el-input class="d_data" v-model="item.phone" placeholder="通知人电话"></el-input>
                </el-form-item>

                <el-button type="danger" @click.prevent="removeDomain(index)">删除</el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="d_add_data" type="success" @click="addDomain">新增通知人</el-button>
              </el-form-item>
              <el-form-item label="通知方式" prop="type">
                <el-select v-model="informType">
                  <el-option v-for="item in informTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择区域" prop="area" v-if="this.isArea">
                <div class="w_region_1">
                  <el-tree :data="treeData" :props="defaultProps" :highlight-current="true" :filter-node-method="filterNode" node-key="id" accordion :expand-on-click-node="!hasChildNodes" @node-click="getCurrentKey" default-expand-all ref="tree">
                  </el-tree>
                  <span style="
                      float: left;
                      width: 400px;
                      text-align: left;
                      margin: 20px 0;
                      color: #555;
                    ">当前选中:
                    <template v-if="areaArr.length > 0">
                      <span v-for="o in areaArr">
                        <i class="el-icon-d-arrow-right"></i>{{ o }}</span>
                    </template>
                    <span v-else>未选中任何值</span>
                  </span>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button class="cancelButton" @click="cancelFrom">取 消</el-button>
              <el-button class="cancelButton" @click="resetArea(index, row)" v-if="isArea">重 置</el-button>
              <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
            </div>
          </template>
        </el-dialog>
        <!-- 区域树 -->
        <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData"></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from 'utils'
export default {
  data() {
    // area自定义表单验证
    let affiliatingArea = (rule, value, callback) => {
      if (this.treename == '未选中任何值') {
        callback(new Error('请选择区域'))
      } else {
        callback()
      }
    }

    // 手机号自定义验证
    let validatePhone = (rule, value, callback) => {
      //console.log(value);
      let phone = value.replace(/\s/g, '') //去除空格
      //校验手机号，号段主要有：130~139、150~153，155~159，180~189、170~171、176~178、190~199
      let regs = /^((13[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(15[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
      if (value.length != '') {
        if (!regs.test(phone)) {
          callback([new Error('手机号输入不合法')])
        } else {
          callback()
        }
      } else {
        callback([new Error('手机号不能为空')])
      }
    }
    return {
      informType: '',
      informTypeList: [
        { id: 1, name: '短信' },
        { id: 2, name: '语音' },
        { id: 3, name: '短信和语音' },
      ],
      //通知人信息
      dynamicValidateForm: [],
      res: null,
      hasChildNodes: false,
      areaArr: [],
      isArea: false,
      defaultExpendAll: false,
      isTreeOpen: 1,
      treename: '未选中任何值',
      // tree data
      treeData: null,
      defaultProps: {
        children: 'areas',
        label: 'name',
      },
      // rules: {
      //   informer: [
      //     {
      //       required: true,
      //       message: "请输入短信通知人姓名",
      //       trigger: "change",
      //     },
      //   ],
      //   phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
      //   area: [{ required: true, validator: affiliatingArea, trigger: "blur" }],
      // },
      tabName: 'jsgl',
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {
        ...this.seefrom,
      },
      //弹出框标题
      title: '',
      //加载标识
      //区域树是否显示
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
      //设备额外信息
      equipment: {
        protocolTypeName: '',
      },
      //分页
      message: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      //新增还是修改
      state: null,
      //新增修改弹框是否显示
      displayForm: false,
      //搜索表单
      seefrom: {
        deviceName: '',
        deviceMark: '',
        deviceTypeName: '',
        status: null,
        areaId: '',
        informer: '',
        phone: '',
      },
      //新增修改查看设备信息
      addEquipment: {
        informer: '',
        phone: '',
        areaId: '',
        deviceId: '',
        areaKey: '',
      },
      // 设备状态
      statusOptions: [
        {
          value: 0,
          label: '创建',
        },
        {
          value: 1,
          label: '在线',
        },
        {
          value: 2,
          label: '离线',
        },
        {
          value: 3,
          label: '故障',
        },
        {
          value: 4,
          label: '断电',
        },
        {
          value: 5,
          label: '平台注册中',
        },
        {
          value: 6,
          label: '平台注册失败',
        },
        {
          value: 7,
          label: '等待设备上线',
        },
        {
          value: 8,
          label: '空闲中',
        },
        {
          value: 9,
          label: '工作中',
        },
      ],
      items: [],
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'deviceName',
          label: '设备名称',
        },
        {
          prop: 'deviceMark',
          label: '设备编码',
        },
        {
          prop: 'deviceTypeName',
          label: '设备类型',
        },
        {
          prop: 'area',
          label: '所属区域',
        },
        {
          prop: 'statusDesc',
          label: '设备状态',
        },
        {
          prop: 'informer',
          label: '通知人姓名',
        },
        {
          prop: 'phone',
          label: '通知人手机号',
        },
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    mountPoint: () => import('public/mountPoint'),
    equipmentListPlus: () => import('./equipmentListPlus'),
    downloadBtn: () => import('public/download'),
  },
  methods: {
    addDomain(item) {
      if (this.dynamicValidateForm.length < 10) {
        this.dynamicValidateForm.push({
          informer: '',
          phone: '',
        })
      } else {
        this.$message.warning('通知人不可超过10位！')
      }
    },
    removeDomain(index) {
      this.dynamicValidateForm.splice(index, 1)
    },
    // 关闭对话框清除数据
    closeDialog() {
      this.addEquipment.phone = ''
      this.addEquipment.informer = ''
    },
    // tree nodes
    getCurrentKey(data, node, vue) {
      this.addEquipment.areaId = data.id
      this.treename = data.name
      if (this.hasChildNodes && node.childNodes.length > 0) {
        this.areaArr = []
        this.res = null
        return
      }
      this.areaArr = []
      let that = this
      function findParent(n) {
        n.data.name && that.areaArr.unshift(n.data.name)
        if (n.parent) {
          findParent(n.parent)
        }
      }
      findParent(node)
      this.res = { data, node, vue }
    },

    // 未完成
    filterNode(value, data, node) {
      return value.some((id) => id == data.id)
    },
    getTree() {
      this.isTreeOpen = 0
      let p1 = this.$axiosget('operation/area/queryAll?')
      let p2 = this.$axiosget('operation/area/findAreaByUserId')
      Promise.all([p1, p2]).then((res) => {
        this.treeData = res[0].data.data
        this.$nextTick(() => {
          this.$refs.tree.filter(res[1].data.data)
        })
      })
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom
      this.$refs.deviceList.pageToOne()
      this.$nextTick(this.$refs.deviceList.getData)
    },
    cancelFrom() {
      this.displayForm = false
      this.reset()
    },
    //重置
    reset() {
      this.seefrom = {
        deviceName: '',
        deviceMark: '',
        deviceTypeName: '',
        status: '',
        areaId: '',
        informer: '',
        phone: '',
      }
    },

    // 批量设置
    toAddNew() {
      this.dynamicValidateForm = []
      this.informType = ''
      this.isArea = true
      // 树数据
      if (this.isTreeOpen === 1) {
        this.getTree()
        this.$nextTick(() => {
          setTimeout(() => {
            let nodes = this.$refs.tree.store.nodesMap
            for (let id in nodes) {
              nodes[id].expanded = false
            }
          }, 500)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(null)
        })
      }
      this.title = '批量设置通知人信息'
      this.state = 1
      this.displayForm = true
      if (this.$refs['addEquipment']) {
        this.$refs['addEquipment'].clearValidate()
        this.treename = '未选中任何值'
      }
    },
    // 重置
    resetArea(index, row) {
      this.$confirm('确认重置该区域配置通知人？', '重置操作', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        this.$axiospost('operation/deviceAlarmInform/deleteDeviceUserByArea', {
          areaId: this.addEquipment.areaId, // 区域id
        }).then((res) => {
          this.$message({
            type: res.data.status === '10000' ? 'success' : 'error',
            message: res.data.status === '10000' ? '操作成功!' : res.data.message || '系统异常',
          })
          if (res.data.status === '10000') {
            this.displayForm = false
            this.subSeefrom()
          }
        })
      })
    },
    // 确定
    submitForm() {
      let submitMsg = false
      // this.$refs["dynamicValidateForm"].validate((valid) => {
      //   if (valid) {
      this.dynamicValidateForm.forEach((element) => {
        let phone = element.phone.replace(/\s/g, '') //去除空格
        //校验手机号，号段主要有：130~139、150~153，155~159，180~189、170~171、176~178、190~199
        let regs = /^1\d{10}$/;
        if (element.phone.length == '') {
          submitMsg = false
          this.$notify({
            message: '手机号不能为空',
            type: 'warning',
          })
          return
        } else {
          if (!regs.test(phone)) {
            submitMsg = false
            this.$notify({
              message: '手机号不合法',
              type: 'warning',
            })
            return
          } else {
            submitMsg = true
          }
        }
      })
      if (submitMsg) {
        if (this.state == 1) {
          this.$axiospost('operation/deviceAlarmInform/addBatchDeviceUser', {
            areaId: this.addEquipment.areaId, // 区域id
            userList: this.dynamicValidateForm,
            informType: this.informType,
          }).then((res) => {
            if (res.data.data) {
              this.$message({
                type: 'error',
                message: res.data.data,
              })
              return
            }
            this.$message({
              type: res.data.status === '10000' ? 'success' : 'error',
              message: res.data.status === '10000' ? '操作成功!' : res.data.message || '系统异常',
            })
            if (res.data.status === '10000') {
              this.displayForm = false
              this.subSeefrom()
            }
          })
        } else if (this.state == 2) {
          this.$axiospost('operation/deviceAlarmInform/addDeviceUser', {
            deviceId: this.addEquipment.deviceId,
            userList: this.dynamicValidateForm,
            informType: this.informType,
          }).then((res) => {
            this.$message({
              type: res.data.status === '10000' ? 'success' : 'error',
              message: res.data.status === '10000' ? '操作成功!' : res.data.message || '系统异常',
            })
            if (res.data.status === '10000') {
              this.displayForm = false
              this.subSeefrom()
            }
          })
        }
      }

      //   }
      // });
    },
    // 编辑
    toEdit(index, row) {
      //console.log(row);
      this.dynamicValidateForm = []
      this.isArea = false
      // this.$nextTick(() => {
      //   this.$refs.tree.setCurrentKey(1392)
      // });
      this.displayForm = true
      this.title = '修改通知人信息'
      this.state = 2
      this.addEquipment = {
        deviceId: row.deviceId,
      }
      this.informType = row.informType
      let informerArr = row.informer.split(',')
      let phoneArr = row.phone.split(',')
      let lengthMax = informerArr.length > phoneArr.length ? informerArr.length : phoneArr.length
      for (var i = 0; i < lengthMax; i++) {
        this.dynamicValidateForm.push({
          informer: informerArr[i] ? informerArr[i] : '',
          phone: phoneArr[i] ? phoneArr[i] : '',
        })
      }
    },
    //删除设备
    deleteDevice(index, row) {
      this.$confirm('确认删除该区域配置通知人？', '删除操作', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(() => {
          this.$axiospost('operation/deviceAlarmInform/deleteDeviceUser', {
            deviceId: row.deviceId,
          }).then((res) => {
            if (res.data.status === '10000') {
              this.$message({ type: 'success', message: '删除成功!' })
            }
            this.subSeefrom()
          })
        })
        .catch(() => {})
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true
      if (mode === 1) this.areaTreeMode = true
      if (mode === 2) this.areaTreeMode = false
      this.areaMode = mode
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode
      if (mode === 1) {
        this.seefrom.areaId = a.id
        this.seefrom.area = a.name
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, 'areaId', null)
          this.addEquipment.regionName = ''
          return
        }
        this.$set(this.addEquipment, 'areaId', a.id)
        this.addEquipment.regionName = a.name
      }
    },
  },
  mounted() {},
}
</script>

<style lang="less">
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
  .tabLv3 {
    .cust_dialog {
      .d_name {
        width: 160px;
        margin-left: 10px;
        margin-right: 10px;
      }
      .d_data {
        width: 160px;
        margin-right: 10px;
      }
      .d_add_data {
        margin-left: 80px;
      }
    }
  }
  .editDialog .el-form .el-input__inner,
  .editDialog .el-form textarea {
    width: 400px;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  .searchForm1 .el-form-item__label {
    padding-left: 0px;
  }
  .w_region_1 {
    width: 540px;
    background: #181c2e;
    border: 1px solid #3d4963;
    padding: 10px;
  }
  .w_region_1 .el-tree {
    background: transparent;
    color: #ccc;
  }
  .w_region_1 .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #306ac9;
  }
  .w_region_1 .el-tree-node__content:hover {
    background-color: #212740;
  }
  .w_region_1 .el-tree-node:focus > .el-tree-node__content {
    background-color: transparent;
  }
  .w_region_1 .el-tree-node__content {
    height: 42px;
    border-bottom: 1px solid #464958;
  }
  .w_region_1 .el-tree-node__expand-icon.expanded {
    transform: rotate(-90deg);
  }
  .checktree {
    color: #555;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/WarningNotice.vue